import { render, staticRenderFns } from "./AllOrders.vue?vue&type=template&id=06c0357c&scoped=true"
import script from "./AllOrders.vue?vue&type=script&lang=js"
export * from "./AllOrders.vue?vue&type=script&lang=js"
import style0 from "./AllOrders.vue?vue&type=style&index=0&id=06c0357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0357c",
  null
  
)

export default component.exports